import styles from './styles/Items.colors.module.scss';
import React from 'react';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { defaultSearchParams } from '../../configs';
import { useFacetLogic } from '../../hooks/useFacetLogic';
export const ItemsColors = ({ fConfig }) => {
    const { facets } = useAlgoliaDataContext();
    const [activeValues, itemClickHandler] = useFacetLogic(fConfig.key, fConfig.singleSelect);
    return (React.createElement("ul", { "data-cy-test": 'CollectionFilter-Colors', className: `list:none d:grid lh:0 ${styles.items}` }, facets[fConfig.key].map(({ value, label }) => {
        const isActiveAsDefault = defaultSearchParams.facets[fConfig.key]?.includes(value);
        const isActive = isActiveAsDefault || activeValues.includes(value);
        return (React.createElement("li", { key: value },
            React.createElement("button", { className: `btn:cleared bdrs:50p trs:all:300 w:100p ${styles.item} ${isActive ? styles.itemActive : ''}`, title: label, onClick: () => { !isActiveAsDefault && itemClickHandler(value); } },
                React.createElement("span", { className: "sr-only" }, label))));
    })));
};
